import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Style from "./gridProgress.module.css";

/**
 * Indeterminate progress for a data grid refetch, sitting at the top of the
 * grid where it is expected and out of the way.
 *
 * Deliberately not @material-table/core's own `loadingType`: its linear variant
 * renders into a zero height box between the table body and the footer, so the
 * bar overlays the pagination controls and disturbs their tooltips.
 *
 * The track keeps its height whether or not the bar is showing, so appearing
 * and disappearing never moves the table. The bar itself is only mounted while
 * busy, so nothing animates in the background.
 */
const GridProgress = ({ busy }) => (
  <div className={Style.track} aria-hidden="true">
    {busy && <LinearProgress />}
  </div>
);

export default GridProgress;
